import Transform from '@ember-data/serializer/transform';
import { A } from '@ember/array';

/**
 * A Transform for a lightweight user-results json array.
 *
 * e.g. [{
 *  'image-thumbnail' : 'https://img.com'
 * },{
 *  'image-thumbnail' : 'https://img2.com'
 * }]
 *
 * will return an array of results.
 */
export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    let userList = A();
    serialized.forEach((userListItemJson) => {
      userList.pushObject(userListItemJson['image-thumbnail']);
    });

    return userList;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    throw new Error('serializing not supported yet.');
  }
});
